import React, { useState } from "react";
import Slider from "react-slick";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { FaPlay } from "react-icons/fa";
import "slick-carousel/slick/slick-theme.css";

const Homebannerslide = () => {
  const images = [
    "https://picsum.photos/id/1015/800/400",
    "https://picsum.photos/id/1016/800/400",
    "https://picsum.photos/id/1018/800/400",
    "https://picsum.photos/id/1020/800/400", // 4th image
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [showPreview, setShowPreview] = useState(false);

  const NextArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute right-2 top-1/2 -translate-y-1/2 bg-opacity-50 text-3xl hover:bg-opacity-70 text-white rounded-full p-2 z-20"
      aria-label="Next"
      type="button"
    >
      <MdKeyboardArrowRight />
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute left-2 top-1/2 -translate-y-1/2 bg-opacity-50 text-3xl hover:bg-opacity-70 text-white rounded-full p-2 z-20"
      aria-label="Previous"
      type="button"
    >
      <MdKeyboardArrowLeft />
    </button>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),

    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: 16,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          zIndex: 20,
          pointerEvents: "none",
        }}
      >
        <ul
          style={{
            margin: 0,
            padding: 0,
            display: "flex",
            gap: 1,
            pointerEvents: "auto",
          }}
        >
          {dots}
        </ul>
      </div>
    ),

    customPaging: (i) => (
      <button
        style={{
          width: 10, // bigger dots for better visibility
          height: 10,
          borderRadius: "50%",
          backgroundColor: "rgba(255,255,255,0.7)",
          border: "none",
          cursor: "pointer",
          transition: "background-color 0.3s",
        }}
        aria-label={`Go to slide ${i + 1}`}
      />
    ),
  };

  return (
    <div
      className="w-full max-w-[783px] mx-auto select-none relative group"
      style={{ position: "relative" }}
    >
      <Slider {...settings}>
        {images.map((src, idx) => (
          <div key={idx} className="relative" style={{ height: 272 }}>
            <div
              style={{
                height: 272,
                backgroundImage: `url(${src})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />

            {/* Black Overlay with hover dimming */}
            <div className="absolute inset-0 bg-black opacity-70 group-hover:opacity-90 transition-opacity duration-300 z-0"></div>

            {/* Caption with dimmed background on hover */}
            <div className="absolute inset-0 flex justify-center items-center px-4 text-center z-10">
              <div className="bg-transparent transition-colors duration-300 p-4 rounded">
                <div className="text-white text-lg font-semibold transition duration-300 group-hover:brightness-[0.4]">
                  {idx === 0 && (
                    <>
                      <h1 className="text-white font-semibold text-3xl  ">
                        Welcome to ZeroMiddleman.com
                      </h1>
                      <h2 className="text-white font-semibold text-lg mb-2">
                        Connecting B2B buyers directly to the SOURCE
                      </h2>
                      <div className="w-[45%] ms-48 text-sm mx-auto">
                        <p className="mb-2">
                          Start selling & Sourcing at right cost from the original source
                          tried of Inflated price neccessery middleman ?
                        </p>
                        <h3 className="mb-2">Your Gateway to Trusted Business
                          your Gateway To Success
                        </h3>
                      </div>
                      <div className="flex justify-center">
                        <h3 className="border-2 border-red-600 mb-9 w-fit px-2 rounded-md text-red-600 mt-1 cursor-pointer">
                          Get Started
                        </h3>
                      </div>
                    </>
                  )}
                  {idx === 1 && (
                    <>
                      <h1 className="text-white font-semibold text-xl mb-2">
                        Connect directly With verified global sources or access
                        Thousands of pot Buyers Worldwide
                      </h1>
                      <div className="w-[55%] ms-48 text-sm mx-auto">
                        <h2>
                          cut out the <span className="text-2xl">middleman</span> and expand yours <span className="text-2xl">reach</span>
                        </h2>
                        <p>EasilDownload all contact in an Excel </p>
                        <p>File and reach at your convenient   </p>
                      </div>
                      <div className="flex justify-center">
                        <h3 className="border-2 border-red-600 w-fit px-2 rounded-md text-red-600 mt-1 cursor-pointer">
                          Get Started
                        </h3>
                      </div>
                    </>
                  )}
                  {idx === 2 && (
                    <>
                      <h1 className="text-white font-semibold mb-2 w-[85%] ms-50 text-3xl mx-auto">
                        Avail our Liaison serves across the globe
                      </h1>
                      <div className="w-[75%] ms-34 mb-2 text-lg mx-auto">
                        <h3>Our Liason Service :A Key to Seamless Global Operations for Buyers as well as seller
                        </h3>
                        <ul className="text-xs space-y-1">
                          <li className="flex items-start">
                            <span className="text-green-600 mr-1">✓</span>
                            <span>Coordination with local sources</span>
                          </li>
                          <li className="flex items-start">
                            <span className="text-green-600 mr-1">✓</span>
                            <span>Conducting quality verification, documentation & certification</span>
                          </li>
                          <li className="flex items-start">
                            <span className="text-green-600 mr-1">✓</span>
                            <span>Providing real-time updates on the source company and orders placed</span>
                          </li>
                          <li className="flex items-start">
                            <span className="text-green-600 mr-1">✓</span>
                            <span>Payment follow-up and sorting out quality and document issues, if any</span>
                          </li>
                          <li className="flex items-start">
                            <span className="text-green-600 mr-1">✓</span>
                            <span>Providing after-sales & service support and acting as the local rep for all</span>
                          </li>
                        </ul>

                      </div>
                      <div className="flex justify-center mt-1">
                        <h3 className="border-2 border-red-600 w-fit px-2 text-red-600 cursor-pointer">
                          click Here
                        </h3>
                      </div>
                    </>
                  )}
                  {idx === 3 && (
                    <>
                      <h1 className="text-white font-semibold mb-2 w-[45%] ms-56 mx-auto text-2xl">
                        Are you the Original source for a product service ?
                      </h1>
                      <div className="w-[45%] ms-48 text-sm mx-auto space-y-2">
                        <p className="">
                          List Your business with for Free Today 
                        </p>
                        <p>Simply Submit your Application andonce they Verfiy that yor're the genuine source,you'll</p>
                        <p>start receving global inquries</p>
                        <p>Don't miss out on this opportunity connect directly with your buyers wordwide !</p>
                      </div>
                      <div className="flex justify-center mt-1">
                        <h3 className="border-2 border-red-600 w-fit px-2 text-red-600 cursor-pointer">
                          Get Started 
                        </h3>
                      </div>
                    </>
                  )}
                  
                </div>
              </div>
            </div>

            {/* Preview Button */}
            {currentSlide === idx && (
              <div className="absolute inset-0 flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
                <button
                  className="text-sm bg-blue-700 bg-opacity-70 hover:bg-opacity-90 hover:brightness-110 flex mt-1 text-white px-4 py-1 rounded transition duration-300"
                  onClick={() => setShowPreview(true)}
                >
                  <FaPlay className="mt-0.5" />
                  <h1 className="ms-2">Preview</h1>
                </button>
              </div>
            )}
          </div>
        ))}
      </Slider>

      {/* Caption Below Banner */}
      <div className="mt-6 flex justify-center text-xl font-semibold">
        <h1 className="text-gray-700">Edit Your Banner Below Here</h1>
      </div>

      {/* Preview Modal */}
      {/* Preview Modal */}
      {showPreview && (
  <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 overflow-auto p-4">
    <div className="relative w-full max-w-4xl md:ms-40 h-[272px] bg-black rounded-md flex justify-center items-center">
      <div className="absolute top-4 -translate-y-12  left-4 text-white text-lg ms-[35%] z-20">
       Just click and See your Banner
      </div>
      <img
        src={images[currentSlide]}
        alt="preview"
        className="w-full h-[272px] object-cover rounded-md opacity-25"
      />
      {/* Caption overlay */}
      <div className="absolute inset-0 flex flex-col justify-center items-center text-white px-6 text-center bg-black bg-opacity-30 rounded-md">
        {currentSlide === 0 && (
          <>
            <h1 className="text-white font-semibold text-xl mb-2">
              Connect directly With verified global sources or access
              Thousands of pot Buyers Worldwide
            </h1>
            <div className="w-[55%] ms-48 text-sm mx-auto">
              <h2>
                cut out the <span className="text-2xl">middleman</span> and expand yours <span className="text-2xl">reach</span>
              </h2>
              <p>EasilDownload all contact in an Excel</p>
              <p>File and reach at your convenient</p>
            </div>
            <div className="flex justify-center">
              <h3 className="border-2 border-red-600 w-fit px-2 rounded-md text-red-600 mt-1 cursor-pointer">
                Get Started
              </h3>
            </div>
          </>
        )}
        {currentSlide === 1 && (
          <>
            <h1 className="text-white font-semibold text-xl mb-2">
              Connect directly With verified global sources or access
              Thousands of pot Buyers Worldwide
            </h1>
            <div className="w-[55%] ms-48 text-sm mx-auto">
              <h2>
                cut out the <span className="text-2xl">middleman</span> and expand yours <span className="text-2xl">reach</span>
              </h2>
              <p>EasilDownload all contact in an Excel</p>
              <p>File and reach at your convenient</p>
            </div>
            <div className="flex justify-center">
              <h3 className="border-2 border-red-600 w-fit px-2 rounded-md text-red-600 mt-1 cursor-pointer">
                Get Started
              </h3>
            </div>
          </>
        )}
        {currentSlide === 2 && (
          <>
            <h1 className="text-white font-semibold mb-2 w-[85%] ms-50 text-3xl mx-auto">
              Avail our Liaison serves across the globe
            </h1>
            <div className="w-[75%] ms-34 mb-2 text-lg mx-auto">
              <h3>
                Our Liason Service : A Key to Seamless Global Operations for Buyers as well as seller
              </h3>
              <ul className="text-xs space-y-1">
                <li className="flex items-start">
                  <span className="text-green-600 mr-1">✓</span>
                  <span>Coordination with local sources</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-1">✓</span>
                  <span>Conducting quality verification, documentation & certification</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-1">✓</span>
                  <span>Providing real-time updates on the source company and orders placed</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-1">✓</span>
                  <span>Payment follow-up and sorting out quality and document issues, if any</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-1">✓</span>
                  <span>Providing after-sales & service support and acting as the local rep for all</span>
                </li>
              </ul>
            </div>
            <div className="flex justify-center mt-1">
              <h3 className="border-2 border-red-600 w-fit px-2 text-red-600 cursor-pointer">
                click Here
              </h3>
            </div>
          </>
        )}
        {currentSlide === 3 && (
          <>
            <h1 className="text-white font-semibold mb-2 w-[45%] ms-56 mx-auto text-2xl">
              Are you the Original source for a product service?
            </h1>
            <div className="w-[45%] ms-48 text-sm mx-auto space-y-2">
              <p>List Your business with for Free Today</p>
              <p>Simply Submit your Application and once they Verfiy that you're the genuine source, you'll</p>
              <p>start receiving global inquiries</p>
              <p>Don't miss out on this opportunity connect directly with your buyers worldwide!</p>
            </div>
            <div className="flex justify-center mt-1">
              <h3 className="border-2 border-red-600 w-fit px-2 text-red-600 cursor-pointer">
                Get Started
              </h3>
            </div>
          </>
        )}
      </div>

      {/* Close Button */}
      <button
        className="absolute top-2 right-2 text-white text-3xl font-bold hover:text-red-600 transition"
        onClick={() => setShowPreview(false)}
        aria-label="Close preview"
      >
        &times;
      </button>
    </div>
  </div>
)}


    </div>
  );
};

export default Homebannerslide;


